import "core-js/modules/web.timers.js";
import isFunction from "lodash/isFunction";
export var scrollToTop = function scrollToTop(delay) {
  if (window && isFunction(window.scrollTo)) {
    if (delay) {
      setTimeout(function () {
        var _window$scrollTo, _window;
        return (_window$scrollTo = (_window = window).scrollTo) === null || _window$scrollTo === void 0 ? void 0 : _window$scrollTo.call(_window, 0, 0);
      }, delay);
    } else {
      var _window$scrollTo2, _window2;
      (_window$scrollTo2 = (_window2 = window).scrollTo) === null || _window$scrollTo2 === void 0 ? void 0 : _window$scrollTo2.call(_window2, 0, 0);
    }
  }
};
var scrollToElement = function scrollToElement(element) {
  element.scrollIntoView({
    behavior: "smooth",
    block: "end",
    inline: "nearest"
  });
};
export var scrollToElementAfterTimeout = function scrollToElementAfterTimeout(element, delay) {
  setTimeout(function () {
    if (element) {
      scrollToElement(element);
    }
  }, delay);
};